<template>
  <ElDialog name="contact-new-modal"
    :visible="show"
    v-on="$listeners"
    v-loading="loading"
    :title="$t('contacts.addContact')"
    append-to-body
  >
    <div>
      <VForm :onSubmit="validateForm" data-vv-scope="contact-new">
        <div slot="row">
          <VGrid>
            <div slot="gridItem" type="5">
              <b>{{ $t('contacts.contactName') }}</b>
              <VInput
                type="text"
                :class="{ 'a-input--error': errors.has('contact-new.name') }"
                placeholder="e.g. Jo Bloggs"
                v-validate="'required'"
                data-vv-name="name"
                :data-vv-as="$t('contacts.contactName')"
                data-vv-delay="1000"
                v-model="contact.title"
                data-ec="new_contact_modal"
                data-et="contact_name_input"
                data-vv-scope="contact-new"
                data-test="contacts-new-name"
                data-hj-suppress
              />
              <VMessage
                type="error"
                subtype="basic"
                v-show="errors.has('contact-new.name')"
                data-test="contacts-new-name-error">
                <template v-slot:icon>
                  <XMarkIcon />
                </template>
                <template v-slot:text>
                  {{ errors.first('contact-new.name') }}
                </template>
              </VMessage>
            </div>
            <div slot="gridItem" type="7">
              <b>{{ $t('contacts.contactEmail') }}</b>
              <VInput
                type="text"
                :class="{ 'a-input--error': errors.has('contact-new.email') }"
                placeholder="e.g. jo@example.com"
                v-validate="'required|isTrimmedEmail'"
                data-vv-name="email"
                :data-vv-as="$t('contacts.contactEmail')"
                data-vv-delay="1000"
                data-ec="new_contact_modal"
                data-et="contact_email_input"
                v-model.trim="contact.email"
                data-vv-scope="contact-new"
                data-test="contacts-new-email"
                data-hj-suppress
              />
              <VMessage
                type="error"
                subtype="basic"
                v-show="errors.has('contact-new.email')"
                data-test="contacts-new-email-error">
                <template v-slot:icon>
                  <XMarkIcon />
                </template>
                <template v-slot:text>
                  {{ errors.first('contact-new.email') }}
                </template>
              </VMessage>
            </div>
          </VGrid>
        </div>
        <div slot="formButtons" type="right">
          <VButton
            type="cta-1"
            data-ec="new_contact_modal"
            data-et="add_contact_button"
            subtype="submit"
            data-test="contacts-new-save-button">
            <CheckIcon />
            <span>{{ $t('contacts.addContact') }}</span>
          </VButton>
        </div>
      </VForm>
    </div>
  </ElDialog>
</template>
<script>
import VButton from '@/components/deprecated/atoms/Button.vue';
import VInput from '@/components/deprecated/atoms/Input.vue';
import VMessage from '@/components/deprecated/atoms/Message.vue';
import VForm from '@/components/deprecated/organisms/Form.vue';
import VGrid from '@/components/deprecated/organisms/Grid.vue';
import { CheckIcon, XMarkIcon } from '@/components/icons/fontIcons';

export default {
  name: 'NewContactModal',
  props: {
    show: Boolean,
  },
  inject: {
    $validator: '$validator',
  },
  data() {
    return {
      contact: {
        title: '',
        email: '',
      },
      loading: false,
    };
  },
  components: {
    VButton,
    VInput,
    VMessage,
    VForm,
    VGrid,
    CheckIcon,
    XMarkIcon,
  },
  watch: {
    show() {
      this.contact = {
        title: '',
        email: '',
      };
    },
  },
  methods: {
    async validateForm(scope) {
      try {
        this.loading = true;
        if (await this.$validator.validateAll(scope)) {
          await this.$store.dispatch('contacts/CREATE', this.contact);
          this.$store.dispatch('contacts/PAGINATE', { page: 1 });
          this.$emit('close');
        }
      } catch (e) {
        if (e.response && e.response.data && e.response.data.errors) {
          Object.keys(e.response.data.errors).forEach((field) => {
            this.errors.add({ field, scope, msg: e.response.data.errors[field][0] });
          });
        }
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
